import React from 'react';
import PropTypes from 'prop-types';
import { ModalWrapper } from 'components/CustomModal';
import {
  ModalContainer,
  IconWrapper,
  Asterisks,
  Title,
  Description,
  PhonesWrapper,
  PhoneColumn,
  PhoneNumber,
  PhoneLabel,
  SupportLink,
  InfoBox,
  InfoText,
  BackButton,
} from './styles';

const WarningTriangleIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ marginLeft: 6 }}
  >
    <path
      d="M10.134 1.5a1 1 0 0 1 1.732 0l8.66 15A1 1 0 0 1 19.66 18H2.34a1 1 0 0 1-.866-1.5l8.66-15z"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M11 7v5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="11" cy="14.5" r="1" fill="currentColor" />
  </svg>
);

function formatSupportDisplay(supportUrl) {
  if (!supportUrl) return 'www.bancotopazio.com.br/atendimento';
  return supportUrl
    .replace(/^https?:\/\//, '')
    .replace(/\/$/, '');
}

function ForgotPasswordModal({ hideModal, appName, supportUrl }) {
  const brandName = appName || 'Banco Topázio';
  const href = supportUrl || 'https://www.bancotopazio.com.br/atendimento';

  return (
    <ModalWrapper
      contentStyle={{
        maxWidth: '620px',
        width: '92%',
        borderRadius: '12px',
        border: 'none',
        padding: 0,
        overflow: 'auto',
        marginRight: 0,
      }}
    >
      <ModalContainer id="forgotPasswordModal">
        <IconWrapper>
          <Asterisks>***</Asterisks>
          <WarningTriangleIcon />
        </IconWrapper>

        <Title>Esqueci minha senha</Title>

        <Description>
          Por questões de segurança, o atendimento momentâneo para recuperação
          de senha é realizado somente por ligação, pelos canais oficiais do{' '}
          {brandName}. Entre em contato com nossa Central de Atendimento. Nossa
          equipe vai orientar você durante o processo.
        </Description>

        <PhonesWrapper>
          <PhoneColumn>
            <PhoneNumber>4002 4466</PhoneNumber>
            <PhoneLabel>Capitais e Regiões Metropolitanas</PhoneLabel>
          </PhoneColumn>
          <PhoneColumn>
            <PhoneNumber>0800 642 8282</PhoneNumber>
            <PhoneLabel>Outras Localidades</PhoneLabel>
          </PhoneColumn>
        </PhonesWrapper>

        <SupportLink href={href} target="_blank" rel="noopener noreferrer">
          {formatSupportDisplay(href)}
        </SupportLink>

        <InfoBox>
          <InfoText>
            Tenha seus dados de identificação em mãos para agilizar o seu atendimento.
          </InfoText>
        </InfoBox>

        <BackButton type="button" onClick={hideModal}>
          Voltar
        </BackButton>
      </ModalContainer>
    </ModalWrapper>
  );
}

ForgotPasswordModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  appName: PropTypes.string,
  supportUrl: PropTypes.string,
};

export default ForgotPasswordModal;
